import { close_menu } from './navigation-mobile.js';
document.addEventListener("DOMContentLoaded", function () {
  var sticky_target = document.getElementsByTagName('header')[0];
  var sticky_distance = window.innerHeight;
  var sticky_lock = false;
  var scroll_pos_prev; //Check if this is an immersive page as we don't want to show the sticky header

  var isImmersivePage = document.body.classList.contains('page-template-page-glo');

  if (sticky_target && !isImmersivePage) {
    var debounce = require('debounce');

    window.addEventListener('scroll', debounce(function () {
      //get the scroll position
      var scroll_pos = window.pageYOffset; //check to see if we've scrolled past the sticky distance

      var scroll_up = sticky_target.classList.contains('sticky-nav-scrollup'); //get the scroll direction

      var scroll_direction = scroll_pos > scroll_pos_prev ? 'down' : 'up'; //get the scroll threshold

      var scroll_threshold = scroll_direction == 'up' ? scroll_pos_prev - scroll_pos > 10 : scroll_pos - scroll_pos_prev > 10; //if the sticky lock is not set and the scroll position is greater than the sticky distance

      if (!sticky_lock && scroll_pos >= sticky_distance) {
        //if we've not scrolled up and the scroll direction is up
        if (!scroll_up || scroll_up && scroll_direction == 'up' && scroll_threshold) {
          //get the sticky target styles
          var sticky_styles = window.getComputedStyle(sticky_target); //if the element is relative, we need to add an offset

          if (sticky_styles.getPropertyValue('position') == 'static' || sticky_styles.getPropertyValue('position') == 'relative') {
            var sticky_height = sticky_target.offsetHeight;
            this.document.body.style.paddingTop = sticky_height + 'px';
          } //add the sticky class


          sticky_target.classList.add('sticky-nav-active');
          sticky_target.classList.add('sticky-nav-transition-enter'); //enable the sticky lock

          sticky_lock = true; //wait 300ms before removing the transition class

          this.setTimeout(function () {
            sticky_target.classList.remove('sticky-nav-transition-enter');
          }, 300);
        }
      } else if (sticky_lock && scroll_pos < sticky_distance || scroll_up && scroll_direction == 'down' && scroll_threshold) {
        //set a default delay
        var delay = 0; // If the mobile menu is open

        if (document.body.classList.contains('mobile-menu-active')) {
          // Close it
          close_menu(); // Delay the sticky nav exit

          delay = 300;
        } //wait for the duration of the delay


        this.setTimeout(function () {
          //remove the sticky lock
          sticky_lock = false; //remove the sticky class

          sticky_target.classList.add('sticky-nav-transition-exit'); //wait 100ms before removing the sticky class

          this.setTimeout(function () {
            this.document.body.style.paddingTop = '';
            sticky_target.classList.remove('sticky-nav-transition-exit');
            sticky_target.classList.remove('sticky-nav-active');
          }, 100);
        }, delay);
      }

      scroll_pos_prev = scroll_pos;
    }, 10));
  }
});